module.exports = __webpack_public_path__ + "static/media/icon-viewID.e2284c70.svg";